export enum CountedState {
    NotCounted = 0,
    PartiallyCounted = 1,
    Counted = 2,
    CashPartiallyCounted = 3,
    CashCounted = 4,
    PinPartiallyCounted = 5,
    PinCounted = 6,
}